import { useMemo } from 'react'
import { useDefaultContentLanguage } from 'hooks/queries/useDefaultContentLanguage'
import { completedFieldsWithResolvedLanguage } from 'components/Wizards/Wizard/Form/completedFieldsWithResolvedLanguage'

export const useCompletedFieldsForRequest = (
  completedFields: Record<string, any>,
  values: { [key: string]: any },
) => {
  const defaultLanguageQuery = useDefaultContentLanguage()
  return useMemo(() => {
    if (!('language' in values)) {
      return completedFields
    }
    return completedFieldsWithResolvedLanguage(
      completedFields,
      values.language,
      defaultLanguageQuery.data?.language,
    )
  }, [completedFields, values, defaultLanguageQuery.data?.language])
}
